import { produce } from 'immer';
import { ITablesState, TTableActions } from '../../types/redux/tables';
import {
    TABLES_STATE_DROP, TABLE_APPEND_FILTER, TABLE_APPEND_FILTERS, TABLE_SET_FILTERS, TABLE_SET_PRIMARY_KEY, TABLE_SET_SELECTED_ROWS, TABLE_SET_SORTERS, TABLE_UPDATE_DATASOURCE,
} from '../actions/tables';

const initialState: ITablesState = {};

export const tables = (state = initialState, action: TTableActions): ITablesState => {
    switch (action.type) {
        case TABLE_SET_SELECTED_ROWS: {
            return produce(state, (draft: ITablesState) => {
                draft[action.payload.tableName] = {
                    ...draft?.[action.payload.tableName],
                    selectedRows: action.payload.selectedRows,
                };
            });
        }
        case TABLE_APPEND_FILTER: {
            return produce(state, (draft: ITablesState) => {
                draft[action.payload.tableName] = {
                    ...draft?.[action.payload.tableName],
                    filters: produce(draft[action.payload.tableName]?.filters || [], (filters) => {
                        const index = filters.findIndex((el) => el.column === action.payload.filter.column);
                        if (index > -1) {
                            filters[index] = action.payload.filter;
                        } else {
                            filters.push(action.payload.filter);
                        }
                    }),
                };
            });
        }
        case TABLE_APPEND_FILTERS: {
            return produce(state, (draft: ITablesState) => {
                const tableFilters = draft[action.payload.tableName]?.filters || [];
                action.payload.filters.forEach((filter) => {
                    const index = tableFilters.findIndex((el) => el.column === filter.column);
                    if (index > -1) {
                        tableFilters[index] = filter;
                    } else {
                        tableFilters.push(filter);
                    }
                });
                draft[action.payload.tableName] = {
                    ...draft?.[action.payload.tableName],
                    filters: tableFilters,
                };
            });
        }
        case TABLE_SET_FILTERS: {
            return produce(state, (draft: ITablesState) => {
                draft[action.payload.tableName] = {
                    ...draft?.[action.payload.tableName],
                    filters: action.payload.filters,
                    filterName: action.payload.filterName,
                };
            });
        }
        case TABLE_SET_SORTERS: {
            return produce(state, (draft: ITablesState) => {
                draft[action.payload.tableName] = {
                    ...draft?.[action.payload.tableName],
                    sorters: action.payload.sorters,
                };
            });
        }
        case TABLE_SET_PRIMARY_KEY: {
            return produce(state, (draft: ITablesState) => {
                draft[action.payload.tableName] = {
                    ...draft?.[action.payload.tableName],
                    primaryKey: action.payload.primaryKey,
                };
            });
        }
        case TABLE_UPDATE_DATASOURCE: {
            return produce(state, (draft: ITablesState) => {
                draft[action.payload.tableName] = {
                    ...draft?.[action.payload.tableName],
                    updateDataSource: action.payload.updateDataSource,
                };
            });
        }
        case TABLES_STATE_DROP: {
            return initialState;
        }
        default: {
            return state;
        }
    }
};
